import React, { useEffect, useState } from 'react'

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { getBrandsApi, getAllModels, getVariant } from '../components/ApiService';
import { IconButton } from '@mui/material';
import Swal from 'sweetalert2';

const CarSelection = ({ carDialog, setCarDialog, handleCarSelection }) => {
    const [brand, setbrand] = useState([])
    const [token, setToken] = useState('')
    const [brandID, setbrandID] = useState('')
    const [carName, getcarName] = useState([])
    const [carVariant, getcarVariant] = useState([])
    const [brandPage, setbrandPage] = useState(1)
    const [brandsize, setbrandsize] = useState(15)
    const [modelPage, setmodelPage] = useState(1)
    const [modelsize, setmodelsize] = useState(15)
    const [step, setStep] = useState(1);

    const [selectedBrand, setSelectedBrand] = useState(null);
    const [selectedModel, setSelectedModel] = useState(null);
    const [selectedFuel, setSelectedFuel] = useState(null);
    const [selectedFuelID, setSelectedFuelID] = useState(null)
    const [selectedModelLogo, setSelectedModelLogo] = useState(null)
    const [modelID, setModelID] = useState(null)
    const [selectedData, setSelectedData] = useState([])
    const [storedCarDtl, setstoredCarDtl] = useState('')


    useEffect(() => {
        // GET TOKEN
        const dtl = localStorage.getItem("user")
        if (dtl) {
            const parsedUser = JSON.parse(dtl)
            // setuserDtl(parsedUser)
            // console.log(parsedUser.token, "CAR-SELECTION PAGE TOKEN")
            setToken(parsedUser.token)
        }

        getBrandList()

        if (brandID) {
            getCarName(); // uses the updated brandID from state
        }
    }, [brandID])

    // GET CAR BRAND 
    const getBrandList = () => {
        getBrandsApi(token, brandPage, brandsize).then((res) => {
            setbrand(res.data.brands)
        }).catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        })
    }

    // CAR BRAND
    const selectCarBrand = (brandNo, brandName) => {
        setbrandID(brandNo)
        setSelectedBrand(brandName)
        console.log(brandName, "brandNo")
        if (brandNo) {
            getCarName(brandNo)
            setStep(2)
        } else {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: "Something went wrong..Try Again!"
            });
        }
        // handleCarSelection();
    }

    // GET MODEL NAME
    const getCarName = (brandNo) => {
        getAllModels(modelPage, modelsize, brandNo).then((res) => {
            console.log(brandNo, "brandID=RES")
            if (res.data.models !== '') {
                getcarName(res.data.models)
            } else {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "info",
                    title: "No Models are listed"
                });
            }
        }).catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        })
    }

    // CAR NAME ON SELECTION
    const selectCarName = (modelName, modelLogo, modelId) => {
        console.log(modelId, "Model ID")
        setSelectedModel(modelName)
        setSelectedModelLogo(modelLogo)
        setModelID(modelId)
        variant()
        setStep(3)
    }

    // VARIANT
    const variant = () => {
        getVariant().then((res) => {
            if (res.data.variants !== '') {
                getcarVariant(res.data.variants)
            } else {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "error",
                    title: "No Variants are listed"
                });
            }
        }).catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        })
    }

    // CAR VARIANT ON SELECTION
    const selectVariant = (variant, variantId) => {
        console.log(variant, "variantName")
        setSelectedFuel(variant)
        setSelectedFuelID(variantId)

        if (selectedBrand && selectedModel && variant) {
            // console.log(selectedBrand, selectedModel, variant, selectedModelLogo, "jjjjjjjjjjjjj")
            const selectedData = {
                brand: selectedBrand,
                brandID: brandID,
                model: selectedModel,
                modelID: modelID,
                logo: selectedModelLogo,
                fuel: variant,
                fuelId: variantId
            }
            handleCarSelection(selectedData)
        }
        // else {
        // handleCarSelection()
        // }
        setStep(1)
    }

    // GO BACK
    const handleBack = () => {
        if (step === 3) {
            setStep(2);
        } else if (step === 2) {
            setStep(1);
        } else if (step === 1) {
            setCarDialog(false)
        } else {
            if (selectedBrand && selectedModel && selectedFuel) {
                const selectedData = {
                    brand: selectedBrand,
                    brandID: brandID,
                    model: selectedModel,
                    modelID: modelID,
                    logo: selectedModelLogo,
                    fuel: selectedFuel,
                    fuelId: selectedFuelID
                };
                handleCarSelection(selectedData);

            } else {
                Swal.fire({
                    icon: "warning",
                    title: "Please complete all selections before closing.",
                    toast: true,
                    position: "top-end",
                    timer: 2000,
                    showConfirmButton: false,
                });
            }
        }
    };



    return (
        <>
            {carDialog && (
                <Dialog
                    open={carDialog}
                    onClose={handleCarSelection}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title" color='primary'>
                        <div className='d-flex align-items-center'>
                            <IconButton color="primary" className='me-2' aria-label="Back" onClick={handleBack}>
                                <KeyboardBackspaceIcon />
                            </IconButton>

                            {step === 1 && (
                                <h3>Select Your Car Manufacturer</h3>
                            )}
                            {step === 2 && (
                                <h3>Select Your Car Model</h3>
                            )}
                            {step === 3 && (
                                <h3>Select Fuel Type</h3>
                            )}
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        {step === 1 && (
                            <>
                                <ul className='carList'>
                                    {brand.map((brands) => (
                                        <li onClick={() => selectCarBrand(brands.brandId, brands.brandName)} key={brands.brandId}>
                                            <img src={brands.logoUrl} className='img-fluid' alt="CarGenie" />
                                            {/* <label> {brands.brandName} </label> */}
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}

                        {step === 2 && carName && (
                            <>
                                <ul className='carList cars'>
                                    {carName.map((model) => (
                                        <li onClick={() => selectCarName(model.modelName, model.logoUrl, model.modelId)} key={model.modelId}>
                                            <img src={model.logoUrl} className='img-fluid' alt="CarGenie" />
                                            <label> {model.modelName} </label>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}

                        {step === 3 && carVariant && (
                            <>
                                <ul className='carList variantList'>
                                    {carVariant.map((variants) => (
                                        <li onClick={() => selectVariant(variants.variantName, variants.variantId
                                        )} key={variants.variantName}>
                                            <img src={variants.logoUrl} className='img-fluid' alt="CarGenie" />
                                            <label> {variants.variantName} </label>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleBack}>{step === 1 ? "Close" : "Back"}</Button>
                        {/* <Button onClick={handleCarSelection} autoFocus>
                            Agree
                        </Button> */}
                    </DialogActions>
                </Dialog>
            )}
        </>
    )
}

export default CarSelection